
import React from 'react';
import { Card, CardContent } from '@/components/ui/card';
import TalkToSales from './TalkToSales';

const BiomarkersSection: React.FC = () => {
  const biomarkers = [
    {
      title: "GLP-1 effect",
      price: "$900/ panelist",
      description: "Includes 2 GLP-1 blood tests data"
    },
    {
      title: "Gut Health Effect", 
      price: "$350/ panelist",
      description: "Includes 2 gut health test kits"
    },
    {
      title: "Metabolic Health Effect",
      price: "$200/ panelist", 
      description: "Includes 2 metabolic health blood test kits"
    },
    {
      title: "Body Composition",
      price: "$150/ panelists",
      description: "Includes 2 DEXA scans data"
    },
    {
      title: "Brain Health Effect",
      price: "$50/ panelist",
      description: "Includes 2 cognitive performance tests"
    }
  ];

  return (
    <div className="mt-16 mb-6 pt-10">
      <div className="text-center max-w-3xl mx-auto mb-10 animate-on-scroll">
        <h3 className="text-2xl font-bold mb-4">
          Add-on Before/After Biomarkers
        </h3>
        <TalkToSales 
          buttonText="Contact us"
          className="bg-primary hover:bg-primary/90 text-white"
        />
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-4 max-w-7xl mx-auto">
        {biomarkers.map((biomarker, index) => (
          <Card key={index} className="bg-white border-gray-300 border p-6 animate-on-scroll">
            <CardContent className="p-0">
              <h4 className="text-lg font-bold mb-4 leading-tight text-gray-800">
                {biomarker.title}
              </h4>
              
              <div className="mb-4">
                <p className="text-xl font-bold text-gray-800">
                  {biomarker.price}
                </p>
              </div>

              <p className="text-sm leading-relaxed text-gray-600">
                {biomarker.description}
              </p>
            </CardContent>
          </Card>
        ))}
      </div>
    </div>
  );
};

export default BiomarkersSection;
